export default class Navigation {

  constructor() {
    this.init();
  }

  init() {
    // Main navigation toggle
    $('.c-application-header__burger').click(function(){
      $('.c-navigation--primary').removeClass('c-navigation--primary--hidden');
      $('.c-overlay--primary-menu').addClass('c-overlay--visible');
    });

    $('.c-navigation--primary .c-navigation__close').click(function(){
      $('.c-navigation--primary').addClass('c-navigation--primary--hidden');
      $('.c-overlay--primary-menu').removeClass('c-overlay--visible');
    });

    $('.c-overlay--primary-menu').click(function(){
      $('.c-navigation--primary').addClass('c-navigation--primary--hidden');
      $('.c-overlay--primary-menu').removeClass('c-overlay--visible');
    });  
  }
}



// WEBPACK FOOTER //
// ./scripts/components/navigation.js